export default "__VITE_ASSET__955830f7__"